import { useUserSettings } from "../../contexts/UserSettingsContext";

const DAYS = [
  { code: "MONDAY", label: "Mon" },
  { code: "TUESDAY", label: "Tue" },
  { code: "WEDNESDAY", label: "Wed" },
  { code: "THURSDAY", label: "Thu" },
  { code: "FRIDAY", label: "Fri" },
  { code: "SATURDAY", label: "Sat" },
  { code: "SUNDAY", label: "Sun" },
];

export function MealPlanSection() {
  const { weekStartDay, updateWeekStartDay } = useUserSettings();

  return (
    <div className="max-w-2xl">
      <h2 className="text-lg font-semibold text-gray-900">Meal Plan</h2>
      <p className="text-sm text-gray-500 mt-1 mb-6">
        Choose which day your meal planning week starts on — for example, the
        day you usually do your grocery shop.
      </p>

      <div className="grid grid-cols-7 gap-2 max-w-md">
        {DAYS.map((day) => {
          const isSelected = weekStartDay === day.code;
          return (
            <button
              key={day.code}
              onClick={() => updateWeekStartDay(day.code)}
              aria-pressed={isSelected}
              className={`flex items-center justify-center px-2 py-2.5 text-sm font-medium rounded-lg border transition-colors ${
                isSelected
                  ? "bg-gray-900 text-white border-gray-900"
                  : "bg-white text-gray-700 border-gray-200 hover:bg-gray-50"
              }`}
            >
              {day.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
